import React from 'react'
import Header from '../../../containers/HeaderContainer'
import HeaderUser from '../../../containers/HeaderUserContainer'
import auth from '../../../modules/auth'
import Footer from '../../../components/Footer/Footer'

import './AuthenticationCodeConfirmation.scss'

const AuthenticationCodeConfirmation = props => {

  const submitAuthenticationCode = (e) => {
    e.preventDefault()
    props.receiveAuthCode(document.getElementById('authenticationCode').value)
  }

  const handleResendSMS = (e) => {
    e.preventDefault()
    props.resendSMS(props.phoneNumber)
  }

  return (
    <div className="authcode-confirm">
      {auth.loggedIn() ?
        <HeaderUser
          {...this.props}
          hideInfo={true}
          hideChat={true}
        />
        :
        <Header/>
      }

      <div>
        <div className="authcode-content">
          <h2 className="authcode-content__title">認証コードの確認</h2>
          {props.errors.authenticationCode &&
            <div className="authcode-content__error-box">{props.errors.authenticationCode}</div>
          }
          <div className="authcode-content__container">
            <form onSubmit={submitAuthenticationCode}>
              <h3 className="authcode-content__title-password">認証コード</h3>
              <p className="authcode-content__annotation px-md-4 ">
                登録されている電話番号にSMSを送信しました。
              </p>
              <p className="authcode-content__annotation px-md-4 ">
                SMSでお伝えした6桁の認証コードを入力してください。
              </p>
              <input
                id="authenticationCode"
                type="text"
                name="authenticationCode"
                className="form-control form-control-find-me"
                placeholder=""
                style={{maxWidth: "280px"}}
                required
              />
              <br/>

              <button
                type="submit"
                className="authcode-content__authentication-code-submit-button custom-control-button" >
                認証する
              </button>
            </form>
            <a className="auth-code" onClick={handleResendSMS}>認証コードの再送信</a>
          </div>

        </div>
      </div>
      <Footer />

    </div>
  )
}

export default AuthenticationCodeConfirmation



// WEBPACK FOOTER //
// ./src/routes/authenticationCodeConfirmation/components/AuthenticationCodeConfirmation.js